module.exports = __webpack_public_path__ + "img/BScout64_ua.5a56c9af.webp";